import { faCheck, faMinus } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Checkbox as CheckboxPrimitive } from "radix-ui"
import type { ComponentPropsWithoutRef } from "react"
import { cn } from "../../lib/utils"

export type CheckboxProps = ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
>

/** Eine Checkbox die zwei Werte repräsentiert */
function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer flex h-5 w-5 shrink-0 items-center justify-center rounded-sm",
        "border border-neutrals-300 bg-white",
        "ring-offset-background transition-colors",
        "focus-visible:ring-2 focus-visible:ring-neutrals-500 focus-visible:ring-offset-2 focus-visible:outline-hidden",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "data-[state=checked]:border-0",
        "data-[state=checked]:bg-primary-blue-600",
        "data-[state=checked]:text-white",
        "dark:data-[state=checked]:bg-primary-blue-400",
        "data-[state=indeterminate]:border-0",
        "data-[state=indeterminate]:bg-primary-blue-600",
        "data-[state=indeterminate]:text-white",
        "dark:data-[state=indeterminate]:bg-primary-blue-400",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}
      >
        <FontAwesomeIcon icon={props.checked === 'indeterminate' ? faMinus : faCheck} className="fa-xs h-3 w-3" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
